type SpinnerProps = { size?: number; className?: string; label?: string }

export function Spinner({ size = 20, className = '', label }: SpinnerProps) {
  return (
    <span role="status" aria-label={label ?? 'Loading'} className={`inline-flex ${className}`}>
      <svg
        aria-hidden="true"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        className="animate-spin"
        fill="none"
        stroke="currentColor"
        strokeWidth={3}
        strokeLinecap="round"
      >
        <path d="M12 3a9 9 0 1 0 9 9" />
      </svg>
    </span>
  )
}
